import { Phone } from "lucide-react";
import { IMAGES } from "../lib/funnelData";

export const Header = ({ countyName }) => (
  <header className="sticky top-0 z-50 bg-canvas/90 backdrop-blur-md border-b border-emeraldx-deep/10" data-testid="site-header">
    <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between gap-3">
      <a href="#top" data-testid="header-logo" className="flex items-center gap-3 min-w-0">
        <img src={IMAGES.logoPlaque} alt="Cann Realty LLC" className="h-9 w-auto" />
        <span className="hidden lg:inline text-[10px] font-mono uppercase tracking-[0.3em] text-stone-500 whitespace-nowrap">SC Real Estate Specialists</span>
      </a>
      <div className="flex items-center gap-2 sm:gap-3">
        {countyName && (
          <span data-testid="header-county-badge" className="hidden md:inline-flex badge-brand">
            {countyName} County
          </span>
        )}
        <a
          href="tel:8643142752"
          data-testid="header-phone-cta"
          className="inline-flex items-center gap-2 rounded-full px-4 py-2 text-xs font-semibold uppercase tracking-[0.12em] text-emeraldx-deep hover:bg-surface transition-colors duration-150"
        >
          <Phone size={15} strokeWidth={2} />
          <span className="hidden sm:inline">(864) 314-2752</span>
        </a>
        <a
          href="#funnel"
          data-testid="header-valuation-button"
          className="inline-flex items-center rounded-full bg-emeraldx-deep hover:bg-emeraldx-deeper text-canvas px-4 py-2 text-[10px] font-semibold uppercase tracking-[0.15em] transition-colors duration-150 active:scale-[0.96] md:absolute md:left-1/2 md:-translate-x-1/2"
        >
          Get My Valuation
        </a>
      </div>
    </div>
  </header>
);
